import React from 'react'
import Head from 'next/head'
import { validateCanonical } from '@utils/validate-canonical-url'
import { useRouter } from 'next/router'

interface HeadMetaDataProps {
  title: string
  metaTitle: string
  metaDescription: string
  canonicalUrl?: string
  coverImage?: string
  twitter?: string
  removeSuffix?: boolean
}

export const HeadMetadata = ({
  title,
  metaTitle,
  metaDescription,
  canonicalUrl,
  coverImage,
  twitter,
  removeSuffix
}: HeadMetaDataProps) => {
  const router = useRouter()
  const suffix = removeSuffix ? '' : ' | Portal Solar'
  return (
    <Head>
      <title>{title + suffix}</title>
      <link
        rel="canonical"
        href={validateCanonical(canonicalUrl, router.asPath)}
      />
      {coverImage && (
        <meta property="og:image" content={coverImage} key="ogimage" />
      )}
      <meta property="og:site_name" content="Portal Solar" key="ogsitename" />

      <meta name="twitter:card" content="summary" key="twcard" />
      {twitter && (
        <meta name="twitter:creator" content={twitter} key="twhandle" />
      )}

      {metaTitle && (
        <meta property="og:title" content={metaTitle + suffix} key="ogtitle" />
      )}
      {metaDescription && (
        <>
          <meta
            property="og:description"
            content={metaDescription}
            key="ogdesc"
          />
          <meta name="description" content={metaDescription}></meta>
        </>
      )}
    </Head>
  )
}
